<template>
    <div class="transfer-box">
        <div class="loading-box">
            <div class="loading-list">
                <div class="loading-item pb-16px" v-for="(i,index) in 5" :key="index">
                    <div class="space-between">

                        <div class="pill animation pill-transfer-title"></div>
                        <div class="pill animation pill-transfer-date"></div>
                    </div>
                    <div class="py-1456px display-flex-center gap-27px">
                        <div class="circle transfer-icon"></div>
                        <div class="transfer-center flex-column-space-between">
                            <div class="pill animation w-100 mb-4px"></div>
                            <div class="pill animation w-80"></div>
                        </div>
                        <div class="circle transfer-icon"></div>
                    </div>

                    <hr class="dashline" />

                    <div class="space-between child-33">
                        <div class="display-flex-center">
                            <div class="pill animation pill-4 pill-8" style="width: 21px;"></div>
                        </div>
                        <div  class="display-flex-center">
                            <div class="pill animation pill-4 pill-8" style="width: 17.5px;"></div>
                        </div>
                        <div  class="display-flex-center">
                            <div class="pill animation pill-4 pill-8" style="width: 80px;"></div>
                        </div>
                    </div>

                    <div class="display-flex-center py-16px">
                        <div class="w-70 display-flex-center gap-4px">
                            <div class="pill animation w-30"></div>
                            <div class="pill animation w-70"></div>
                        </div>
                    </div>
                    
                    <div class="display-flex-center">
                        <div class="w-50 display-flex-center gap-4px">
                            <div class="pill animation w-70"></div>
                            <div class="pill animation w-30"></div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Loading2'
    }
</script>


<style scoped src="../../assets/css/loading/index.css"></style>